module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-message",
    class: {
      own: _vm.isOwn
    }
  }, [_c('div', {
    staticClass: "bubble"
  }, [(_vm.hasFiles) ? _c('div', {
    staticClass: "files"
  }, _vm._l((_vm.message.files), function(f) {
    return _c('div', {
      key: f.id || f.url,
      staticClass: "file-item"
    }, [(_vm.isImage(f)) ? [_c('a', {
      staticClass: "img-link",
      attrs: {
        "href": f.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": f.url,
        "alt": f.name || 'imagem'
      }
    })])] : [_c('a', {
      staticClass: "file-link",
      attrs: {
        "href": f.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('span', {
      staticClass: "ico"
    }, [_vm._v("📎")]), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(f.name || 'arquivo'))]), _vm._v(" "), _c('span', {
      staticClass: "meta"
    }, [_vm._v(_vm._s(_vm.prettySize(f.size)))])])]], 2)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.textToShow) ? _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.textToShow))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.message.timestamp)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-284d8096","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/chat-plugin/components/ChatMessage.vue
// module id = 1747
// module chunks = 18